import React, { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';
import { rowActions as TEXT } from 'locales/en/dispute';

const DisputeActions = ({
  isOpen,
  onClickOpen,
  onClose,
  dispute,
  position,
}) => {
  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewItem = (
      <Link
        to={`/disputes/${dispute.id}`}
        // onClick={() => dispatch(getTransactionById(dispute.id))}
        className={className}
      >
        {TEXT.view}
      </Link>
    );
    const exportPayoutTransactions = (
      <span className={className}>Export Payout Transactions</span>
    );
    let options = [viewItem, exportPayoutTransactions];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

DisputeActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  dispute: PropTypes.shape({}),
};
DisputeActions.defaultProps = {
  position: 'bottom',
  dispute: {},
};

export default memo(DisputeActions);
